export enum TypeDevice {
    desktop,
    mobile,
    all
}
